/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-named-as-default */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */

import React, { useEffect, useMemo, useState } from 'react';
import {
  Avatar, IconButton, Divider, Typography, Button, Tooltip,
} from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import type { AxiosResponse } from 'axios';
import axios from 'axios';
import { useSelector } from 'react-redux';
import Popper from '@mui/material/Popper';
import PopupState, { bindToggle, bindPopper } from 'material-ui-popup-state';
import Fade from '@mui/material/Fade';
import Paper from '@mui/material/Paper';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import type { Cell } from 'react-table';
import { useSnackbar } from 'notistack';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import DeleteIcon from '@mui/icons-material/Delete';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CustomLoader from 'shared-components/components/CustomLoader';
import CustomTable from 'shared-components/tables/CustomTable';
import PrimayButton from 'shared-components/components/PrimayButton';
import type { RootState } from 'mainStore';
import type { IDataObject } from 'formsTypes';
import LinearProgress from '@mui/material/LinearProgress';
import { withStyles } from '@mui/styles';
import StradaSearch from 'admin/buildingSection/budget-calendar/components/StradaSearch';
import AvatarGroup from '@mui/material/AvatarGroup';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import InputField from 'shared-components/inputs/InputField';
import EditIcon from '@mui/icons-material/Edit';
import Filters from './Filters';
import CreateDialog from './CreateDialog';
import type {
  IDetail, Iassignee, IErrorResponse, IPaginationRes,
} from './types';

function AIIcon(): JSX.Element {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M32.0234 15.5C32.8203 15.5 33.5469 15.7109 34.2031 16.1328C34.9062 16.5078 35.4688 17.0469 35.8906 17.75C36.3125 18.4062 36.5234 19.1562 36.5234 20C36.5234 20.8438 36.3125 21.6172 35.8906 22.3203C35.4688 22.9766 34.9062 23.5156 34.2031 23.9375C33.5469 24.3125 32.8203 24.5 32.0234 24.5V30.4766C32.0234 31.3203 31.7188 32.0469 31.1094 32.6562C30.5469 33.2188 29.8438 33.5 29 33.5H11C10.1562 33.5 9.42969 33.2188 8.82031 32.6562C8.25781 32.0469 7.97656 31.3203 7.97656 30.4766V24.5C7.17969 24.5 6.42969 24.3125 5.72656 23.9375C5.07031 23.5156 4.53125 22.9766 4.10938 22.3203C3.6875 21.6172 3.47656 20.8438 3.47656 20C3.47656 19.1562 3.6875 18.4062 4.10938 17.75C4.53125 17.0469 5.07031 16.5078 5.72656 16.1328C6.42969 15.7109 7.17969 15.5 7.97656 15.5V12.4766C7.97656 11.6797 8.25781 11 8.82031 10.4375C9.42969 9.82812 10.1562 9.52344 11 9.52344H15.5C15.5 8.67969 15.6875 7.92969 16.0625 7.27344C16.4844 6.57031 17.0234 6.03125 17.6797 5.65625C18.3828 5.23438 19.1562 5.02344 20 5.02344C20.8438 5.02344 21.5938 5.23438 22.25 5.65625C22.9531 6.03125 23.4922 6.57031 23.8672 7.27344C24.2891 7.92969 24.5 8.67969 24.5 9.52344H29C29.8438 9.52344 30.5469 9.82812 31.1094 10.4375C31.7188 11 32.0234 11.6797 32.0234 12.4766V15.5ZM13.25 19.2266C13.25 19.8828 13.4609 20.4219 13.8828 20.8438C14.3516 21.2656 14.8906 21.4766 15.5 21.4766C16.1094 21.4766 16.625 21.2656 17.0469 20.8438C17.5156 20.4219 17.75 19.8828 17.75 19.2266C17.75 18.6172 17.5156 18.1016 17.0469 17.6797C16.625 17.2109 16.1094 16.9766 15.5 16.9766C14.8906 16.9766 14.3516 17.2109 13.8828 17.6797C13.4609 18.1016 13.25 18.6172 13.25 19.2266ZM25.9766 27.5234V24.5H14.0234V27.5234H25.9766ZM24.5 21.4766C25.1094 21.4766 25.625 21.2656 26.0469 20.8438C26.5156 20.4219 26.75 19.8828 26.75 19.2266C26.75 18.6172 26.5156 18.1016 26.0469 17.6797C25.625 17.2109 25.1094 16.9766 24.5 16.9766C23.8906 16.9766 23.3516 17.2109 22.8828 17.6797C22.4609 18.1016 22.25 18.6172 22.25 19.2266C22.25 19.8828 22.4609 20.4219 22.8828 20.8438C23.3516 21.2656 23.8906 21.4766 24.5 21.4766Z' fill='#00CFA1' />
    </svg>
  );
}
function TaskIcon(): JSX.Element {
  return (
    <svg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M34.9766 12.4766H21.4766V15.5H34.9766V12.4766ZM34.9766 24.5H21.4766V27.5234H34.9766V24.5ZM10.2969 18.5234L5.02344 13.1797L7.13281 11.0703L10.2969 14.2344L16.625 7.90625L18.8047 10.0156L10.2969 18.5234ZM10.2969 30.4766L5.02344 25.2031L7.13281 23.0938L10.2969 26.2578L16.625 19.9297L18.8047 22.0391L10.2969 30.4766Z' fill='#00CFA1' />
    </svg>
  );
}
const BorderLinearProgress = withStyles(() => ({
  root: {
    height: 4,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: '#eeeeee',
  },
  bar: {
    borderRadius: 5,
    backgroundColor: '#00CFA1',
  },
}))(LinearProgress);
interface IMessage {
  message: string;
}
interface IData {
  detail: IMessage;
  message: string;
  result: IMessage;
  task_id: string;
}
interface IResponse {
  data: IData;
}

export default function ChecklistList(): JSX.Element {
  const queryClient = useQueryClient();
  const currentUserRole = useSelector((state: RootState) => state.workspaces.userPermission.currentUserRole);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [search, setSearch] = useState<string>('');
  const [assignees, setAssignees] = useState<number[]>([]);
  const [author, setAuthor] = useState<number[]>([]);
  const [startDate, setStartDate] = useState<Date | undefined>(undefined);
  const [endDate, setEndDate] = useState<Date | undefined>(undefined);
  const [open, setOpen] = useState<boolean>(false);
  const [openBlank, setOpenBlank] = useState<boolean>(false);
  const [openAI, setOpenAI] = useState<boolean>(false);
  const [openProgress, setOpenProgress] = useState<boolean>(false);
  const [isDuplicate, setIsDuplicate] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<number | string>();
  const [templateName, setTemplateName] = useState<string>('');
  const [templateId, setTemplateId] = useState<number>(-1);
  const [templateDetail, setTemplateDetail] = useState<string>('');
  const [progressValue, setProgressValue] = useState<number>(0);
  const [disableAIbtn, setDisableAIbtn] = useState<boolean>(false);
  const [data, setData] = useState<IDetail[]>();
  const [getNextData, setgetNextData] = useState<boolean>(false);
  const [cursor, setCursor] = useState<string | null | undefined>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [filteredDataLoading, setFilteredDataLoading] = useState<boolean>(false);

  const currentWorkspace = useSelector(
    (state: RootState) => state.workspaces.currentWorkspace.currentWorkspace,
  );

  const {
    data: allTemplates = { next: null, previous: null, results: [] },
    isLoading: loadMore, isFetching,
  } = useQuery(
    ['get/checklist-template', search, assignees, author, startDate, endDate],
    async () => axios({
      url: `/api/checklist-template/?workspace=${currentWorkspace.id}`,
      method: 'get',
      params: {
        search,
        assignee: assignees,
        author,
        start_date: startDate !== undefined ? moment(startDate).format('MMMM DD,YYYY') : null,
        end_date: endDate !== undefined ? moment(endDate).format('MMMM DD,YYYY') : null,
      },
    }),
    {
      enabled: currentWorkspace.id !== 0,
      select: (res: AxiosResponse<IPaginationRes>) => res.data,
      onSuccess: (res) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        setCursor(res.next?.split('cursor=')[1]?.split('?')[0]);
        setData(res.results);
        setIsLoading(false);
      },
    },
  );
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { data: loadMoreData } = useQuery(
    ['get/loadmoretasks', cursor],
    async () => axios({
      url: `/api/checklist-template/?cursor=${cursor}`,
      method: 'GET',

    }),
    {
      enabled: getNextData && cursor !== null,
      select: (res: AxiosResponse<IPaginationRes>) => res.data,
      onSuccess: () => {
        setFilteredDataLoading(false);
      },
    },
  );
  const GetNextCursorData = (): void => {
    if (allTemplates.next !== null) {
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      loadMoreData && loadMoreData.next !== null ? setCursor(loadMoreData.next.split('cursor=')[1]?.split('?')[0]) : '';
      setgetNextData(true);
      setFilteredDataLoading(true);
    } else {
      setgetNextData(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  };
  useEffect(() => {
    if (getNextData && cursor !== null && loadMoreData !== undefined && data !== undefined) {
      setData([...data, ...loadMoreData.results]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadMoreData]);
  const handleResetFilters = (): void => {
    setSearch('');
    setAssignees([]);
    setAuthor([]);
    setStartDate(undefined);
    setEndDate(undefined);
  };

  const { mutate: deleteTemplate, isLoading: deleteLoader } = useMutation(
    async (id: number | string) => axios({
      url: `/api/checklist-template/${id}`,
      method: 'DELETE',
    }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries('get/checklist-template').then();
        enqueueSnackbar('Deleted Successfully');
      },
    },
  );

  const getChecklistPagePermissions = (): boolean => {
    if (currentUserRole !== null) {
      if (currentUserRole.role !== 2) {
        return true;
      }
      return false;
    }
    return false;
  };

  const renderAuthor = (id: number): JSX.Element => {
    const authors = currentWorkspace.members.filter(
      (singleAuthor) => singleAuthor.id === id,
    );
    if (authors.length === 1) {
      return (
        <div className='d-flex align-items-center'>
          <Avatar
            sx={{ height: '28px', width: '28px' }}
            src={`${process.env.REACT_APP_IMAGE_URL}${authors[0].avatar}`}
          />
          <span style={{ paddingLeft: '16px' }}>
            {authors[0].name}
          </span>
        </div>
      );
    }
    return (
      <div className='table-cell-wrapper'>
        <Avatar
          sx={{ height: '28px', width: '28px' }}
          src=''
        />
        <span style={{ paddingLeft: '16px' }}>No Author</span>
      </div>
    );
  };

  const { mutate: onCreateAIChecklistTemplate } = useMutation(async () => axios({
    url: 'api/chat-gpt/generate-checklist/',
    method: 'post',
    data: {
      template_name: templateName,
      description: templateDetail,
    },
  }), {
    onSuccess: (res) => {
      setOpenAI(false);
      localStorage.setItem('template_name', templateName);
      localStorage.setItem('description', templateDetail);
      navigate(`/workspace/settings/create-checklist-template/${templateId}?taskId=${res.data.detail.task_id}`);

      setTemplateName('');
      setTemplateDetail('');
    },
    onError: (res: IResponse) => {
      setOpenAI(false);
      enqueueSnackbar(res.data.detail.message, {
        variant: 'error',
        content: (key, message) => (
          <div className='text-white bg-danger ps-4 pe-5 py-3'>
            {message}
          </div>
        ),
      });
    },
  });

  const { mutate: onCreateChecklistTemplate } = useMutation(async () => axios({
    url: `/api/checklist-template/?workspace=${currentWorkspace.id}`,
    method: 'post',
    data: {
      template_name: templateName,
    },
  }), {
    onSuccess: (res) => {
      if (openAI) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        setTemplateId(res.data.detail.id);
        onCreateAIChecklistTemplate();
      } else {
        navigate(`/workspace/settings/create-checklist-template/${res.data.detail.id}`);
        setOpenBlank(false);
        setTemplateName('');
        setTemplateDetail('');
      }
    },
    onError: (res: IErrorResponse) => {
      setDisableAIbtn(false);
      if (res.data.response.code === 'unique') {
        enqueueSnackbar('Template Name Already Exist', {
          variant: 'error',
          content: (key, message) => (
            <div className='text-white bg-danger ps-4 pe-5 py-3'>
              {message}
            </div>
          ),
        });
      } else if (res.data.response.message) {
        enqueueSnackbar(res.data.response.message, {
          variant: 'error',
          content: (key, message) => (
            <div className='text-white bg-danger ps-4 pe-5 py-3'>
              {message}
            </div>
          ),
        });
      }
    },
  });

  const { mutate: onDuplicateChecklistTemplate, isLoading: duplicateLoader } = useMutation(
    async () => axios({
      url: '/api/checklist-template/duplicate_checklist/',
      method: 'post',
      data: {
        template: selectedId,
        template_name: templateName,
      },
    }),
    {
      onSuccess: (res) => {
        setOpenBlank(false);
        setTemplateName('');
        setIsDuplicate(false);
        navigate(`/workspace/settings/create-checklist-template/${res.data.id}`);
        enqueueSnackbar('Duplicated Successfully');
      },
      onError: (res: IErrorResponse) => {
        setDisableAIbtn(false);
        if (res.data.response.code === 'unique') {
          enqueueSnackbar('Template Name Already Exist', {
            variant: 'error',
            content: (key, message) => (
              <div className='text-white bg-danger ps-4 pe-5 py-3'>
                {message}
              </div>
            ),
          });
        } else if (res.data.response.message) {
          enqueueSnackbar(res.data.response.message, {
            variant: 'error',
            content: (key, message) => (
              <div className='text-white bg-danger ps-4 pe-5 py-3'>
                {message}
              </div>
            ),
          });
        }
      },
    },
  );

  const handleCreate = (): void => {
    if (isDuplicate) {
      onDuplicateChecklistTemplate();
    } else {
      onCreateChecklistTemplate();
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Name',
        accessor: 'template_name',
        width: '30%',
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { value, row } = cell;
          const { original } = row;
          const newVal: string = value;
          return (
            <div
              style={{ color: '#00CFA1' }}
              aria-hidden='true'
              onClick={getChecklistPagePermissions() ? (): void => {
                navigate(`/workspace/settings/create-checklist-template/${original.id}`);
              } : undefined}
            >
              {newVal}
            </div>
          );
        },
      },
      {
        Header: 'Task',
        accessor: 'num_of_tasks',
        width: '13%',
      },
      {
        Header: 'Assignees',
        accessor: 'assignees',
        width: '13%',
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { value } = cell;
          const newVal: [] = value;
          return (
            <AvatarGroup max={3} className='flex-row-reverse' style={{ width: 'fit-content' }}>
              {newVal.map((assignee: Iassignee) => (
                <Avatar key={assignee.id} alt={assignee.name} src={`${process.env.REACT_APP_IMAGE_URL}${assignee.avatar}`} sx={{ height: '28px', width: '28px' }} />
              ))}
            </AvatarGroup>
          );
        },
      },
      {
        Header: 'Author',
        accessor: 'author',
        width: '20%',
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { value } = cell;
          const newVal: number = value;
          return (
            <div>
              {renderAuthor(newVal)}
            </div>
          );
        },
      },
      {
        Header: 'Created',
        accessor: 'created_at',
        width: '23%',

        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { value } = cell;
          const newVal: string = value;
          return (
            <div>
              {moment(newVal).format('LLL')}
            </div>
          );
        },
      },
      {
        Header: '',
        accessor: 'account_new',
        width: '3%',
        Cell: (cell: Cell<IDataObject>): JSX.Element => {
          const { row } = cell;
          const { original } = row;
          return (
            <div
              style={{
                textAlign: 'right',
                marginRight: '1rem',
              }}
            >
              {getChecklistPagePermissions()
                && (
                  <PopupState variant='popper' popupId='demo-popup-popper'>
                    {(popupState): JSX.Element => (
                      <div>
                        <IconButton {...bindToggle(popupState)}>
                          <MoreHorizIcon />
                        </IconButton>
                        <Popper {...bindPopper(popupState)} transition>
                          {({ TransitionProps }): JSX.Element => (
                            <ClickAwayListener
                              onClickAway={(): void => {
                                popupState.close();
                              }}
                            >
                              <Fade {...TransitionProps} timeout={350}>
                                <Paper className='checklist-list-popover'>
                                  <div
                                    className='chart-btn'
                                    onClick={(): void => {
                                      navigate(`/workspace/settings/create-checklist-template/${original.id}`); popupState.close();
                                    }}
                                    aria-hidden='true'
                                  >
                                    <EditIcon className='fas fa-pen edit-icon fa-lg edit-delete-icon' />
                                    <span className='edit-delete-text '> Edit</span>
                                  </div>
                                  <div
                                    className='chart-btn'
                                    onClick={(): void => {
                                      setOpenBlank(true);
                                      setIsDuplicate(true);
                                      setSelectedId(original.id);
                                      popupState.close();
                                    }}
                                    aria-hidden='true'
                                  >
                                    <FileCopyIcon className='edit-delete-icon' />
                                    <span className='edit-delete-text '> Duplicate</span>
                                  </div>
                                  <div
                                    className='chart-btn'
                                    onClick={(): void => {
                                      if (original.id !== undefined) {
                                        deleteTemplate(original.id);
                                      }
                                      popupState.close();
                                    }}
                                    aria-hidden='true'
                                  >
                                    <DeleteIcon className='edit-delete-icon' />
                                    <span className='edit-delete-text '>
                                      Delete
                                    </span>
                                  </div>
                                </Paper>
                              </Fade>
                            </ClickAwayListener>
                          )}
                        </Popper>
                      </div>
                    )}
                  </PopupState>
                )}
            </div>
          );
        },
      },
    ],
    [currentWorkspace],
  );

  return (
    <>
      {!isFetching && data?.length === 0 && search === '' && assignees.length === 0 && author.length === 0 && startDate === undefined && endDate === undefined
        ? (
          <div className='empty-array-wrapper'>
            <p>No checklist templates</p>
            {getChecklistPagePermissions()
              && (
                <div className='create-new-button'>
                  <PrimayButton
                    onClick={(): void => {
                      setOpen(true);
                    }}
                  >
                    Create new
                  </PrimayButton>
                </div>
              )}
          </div>
        )
        : (
          <div className='checklist-wrapper'>
            <div className='header'>
              <Typography className='header-text'>Checklists</Typography>
              <div className='right-side'>
                <div className='search-wrapper'>
                  <StradaSearch value={search} setSearch={setSearch} placeholder='Search' />
                </div>
                {getChecklistPagePermissions()
                  && (
                    <div className='button-wrapper'>
                      <PrimayButton
                        onClick={(): void => {
                          setOpen(true);
                        }}
                      >
                        Create new
                      </PrimayButton>
                    </div>
                  )}
              </div>
            </div>
            <div className='filters-wrapper'>
              <Filters
                assignees={assignees}
                setAssignees={setAssignees}
                author={author}
                setAuthor={setAuthor}
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
              />
            </div>
            {data?.length !== 0
              ? (
                <div className='vendor-table-wrapper'>
                  <Divider sx={{ mt: 3, mb: 0.9 }} />
                  {isLoading || deleteLoader || duplicateLoader ? <div style={{ height: '60vh' }} className='vh-50 d-flex justify-content-center align-items-center'><CustomLoader /></div>
                    : (
                      <CustomTable
                        {...{
                          columns,
                          data: data !== undefined ? data : [],
                        }}
                      />
                    )}
                  {filteredDataLoading && <div style={{ height: '20vh' }} className='d-flex justify-content-center align-items-center'><CustomLoader /></div>}
                  <div className='mytasks-load-more'>
                    {!isFetching && data !== undefined && data.length > 0 && !filteredDataLoading && loadMoreData?.next !== null && allTemplates.next !== null && <p aria-hidden='true' onClick={(): void => { GetNextCursorData(); }}> Load more </p>}
                  </div>
                </div>
              )
              : (
                <div className='empty-array-wrapper'>
                  <p>No templates were found matching your search</p>
                  <div className='create-new-button'>
                    <PrimayButton
                      onClick={handleResetFilters}
                    >
                      Reset filters
                    </PrimayButton>
                  </div>
                </div>
              )}
          </div>
        )}
      <Dialog
        open={open}
        keepMounted
        onClose={(): void => { setOpen(false); }}
      >
        <DialogContent style={{ width: 550, marginBottom: '20px' }}>
          <p className='create-template-title'>Create New Template</p>
          <div className='parent-grid'>
            <div aria-hidden='true' className='template-type-wrap' onClick={(): void => { setOpenAI(true); setOpen(false); }}>
              <div className='mt-1 mb-3 d-flex justify-content-center align-items-center'><AIIcon /></div>
              <h5>Generate with AI</h5>
              <h6>Use Strada Al to generate a custom workflow for your use case.</h6>
            </div>
            <div aria-hidden='true' className='template-type-wrap' onClick={(): void => { setOpenBlank(true); setOpen(false); }}>
              <div className='mt-1 mb-3 d-flex justify-content-center align-items-center'><TaskIcon /></div>
              <h5>Start a Blank Workflow</h5>
              <h6>Create from scratch</h6>
            </div>
          </div>
        </DialogContent>
      </Dialog>
      <CreateDialog
        openAI={openAI}
        disableAIbtn={disableAIbtn}
        templateName={templateName}
        templateDetail={templateDetail}
        setOpenAI={setOpenAI}
        setIsDuplicate={setIsDuplicate}
        setTemplateName={setTemplateName}
        setTemplateDetail={setTemplateDetail}
        setDisableAIbtn={setDisableAIbtn}
        handleCreate={handleCreate}
      />
      {/* <Dialog
        open={openAI}
        keepMounted
      >
        <DialogContent style={{ width: 500, marginBottom: '20px', padding: '0px' }}>
          <img src={`${process.env.REACT_APP_ASSESTS_URL}AIImage.webp`} alt='' />
          <div style={{ padding: '20px' }}>
            <p className='create-template-title'>Strada AI Checklist</p>
            <div className='create-template-div'>
              <InputField
                type='text'
                label='Name'
                name='name'
                value={templateName}
                inputProps={{ maxLength: 150 }}
                onChange={(event): void => {
                  setTemplateName(event.target.value);
                }}
              />
              <p className='bottom-text'>Specific checklist names work best</p>
            </div>
            <div className='create-template-div'>
              <InputField
                type='text'
                name='detail'
                value={templateDetail}
                inputProps={{ maxLength: 250 }}
                placeholder='Additional instructions. e.g., “Give me a maximum of 10 steps, the last step needs to be approved by the property manager”'
                rows={4}
                multiline
                onChange={(event): void => {
                  setTemplateDetail(event.target.value);
                }}
              />
              <p className='bottom-text'>This can help fine tune your checklist.</p>
            </div>
          </div>
        </DialogContent>
        <DialogActions style={{ paddingRight: '20px' }}>
          <Button
            style={{ textTransform: 'inherit' }}
            onClick={(): void => {
              setOpenAI(false);
              setIsDuplicate(false);
              setTemplateName('');
              setTemplateDetail('');
            }}
            color='primary'
          >
            Cancel
          </Button>
          {templateName === '' || templateName.length > 149 || templateDetail.length > 249
            ? (
              <Tooltip title={<span>{templateName === '' ? 'Enter Template Name' : templateName.length > 149 ? 'Template Name is too long' : templateDetail.length > 249 ? 'Template description is too long' : ''}</span>}>
                <Button
                  variant='contained'
                  style={{ textTransform: 'inherit', color: '#8D8D8D', background: '#EBEBE4' }}

                >
                  Generate with AI
                </Button>
              </Tooltip>
            )
            : (
              <Button
                variant='contained'
                onClick={(): void => {
                  setDisableAIbtn(true);
                  handleCreate();
                }}
                style={{ textTransform: 'inherit', color: 'white', background: '#00CFA1' }}
                disabled={disableAIbtn}
              >
                Generate with AI
              </Button>
            )}
        </DialogActions>
      </Dialog> */}
      <Dialog
        open={openBlank}
        keepMounted
      >
        <DialogContent style={{ width: 500, marginBottom: '20px' }}>
          <p className='create-template-title'>{isDuplicate ? 'Create Duplicate Template' : 'Create Template'}</p>
          <div className='create-template-div'>
            <InputField
              type='text'
              label='Name'
              name='name'
              value={templateName}
              inputProps={{ maxLength: 150 }}
              onChange={(event): void => {
                setTemplateName(event.target.value);
              }}
            />
          </div>
        </DialogContent>
        <DialogActions style={{ paddingRight: '20px' }}>
          <Button
            style={{ textTransform: 'inherit' }}
            onClick={(): void => {
              setOpenBlank(false);
              setIsDuplicate(false);
              setTemplateName('');
            }}
            color='primary'
          >
            Cancel
          </Button>
          {templateName === '' || templateName.length > 149
            ? (
              <Tooltip title={<span>{templateName === '' ? 'Enter Template Name' : templateName.length > 149 ? 'Template description is too long' : ''}</span>}>
                <Button
                  variant='contained'
                  style={{ textTransform: 'inherit', color: '#8D8D8D', background: '#EBEBE4' }}

                >
                  Create
                </Button>
              </Tooltip>
            )
            : (
              <Button
                variant='contained'
                onClick={(): void => {
                  setDisableAIbtn(true);
                  handleCreate();
                }}
                style={{ textTransform: 'inherit', color: 'white', background: '#00CFA1' }}
                disabled={disableAIbtn}
              >
                Create

              </Button>
            )}

        </DialogActions>
      </Dialog>
      <Dialog
        open={openProgress}
        keepMounted
      >
        <DialogContent style={{ width: 500, marginBottom: '20px' }}>
          <div className='d-flex justify-content-center align-items-center'><img src={`${process.env.REACT_APP_ASSESTS_URL}robot.webp`} alt='' /></div>
          <div style={{ margin: '20px 0px', background: 'red' }}><BorderLinearProgress variant='determinate' value={progressValue} /></div>
          <p className='robot-dialog-text'>Generating your tasks...</p>

        </DialogContent>
      </Dialog>
    </>
  );
}
